import './assets/main.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "@/utils/request";
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import VueQriously from 'vue-qriously'

// use
Vue.use(mavonEditor)
Vue.use(VueQriously)

Vue.config.productionTip = false

Vue.use(ElementUI, { size: "small" });

Vue.prototype.request=request
Vue.prototype.$echarts = echarts

// 全局积分刷新方法
Vue.prototype.$refreshPoints = function() {
  // 触发事件通知 Helper.vue 更新积分
  this.$root.$emit('refresh-points')
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
